import { Component } from 'solid-js';
import { ActionModal } from '../action-modal';
import { ErrorIcon } from '../../../../components';
import {isMobile} from '../../../../hooks/isMobile';

interface TransactionCanceledModalProps {
    onClose: () => void;
}

export const TransactionCanceledModal: Component<TransactionCanceledModalProps> = props => {
    return (
        <ActionModal
            headerTranslationKey="actionModal.transactionCanceled.header"
            textTranslationKey="actionModal.transactionCanceled.text"
            icon={<ErrorIcon size="m" />}
            onClose={() => props.onClose()}
            showButton={isMobile() ? 'close' : undefined}
            data-tc-transaction-canceled-modal="true"
        />
    );
};
